const { default: utils } = require('./utils');

const IS_AUTHENTICATED = JSON.parse(
  document.getElementById("is-authenticated").textContent
);

const SLUG = JSON.parse(
  document.getElementById("slug").textContent
);

const validateEmail = email => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
const subscribe = ({ email, csrftoken, slug }) => {
  // Create a new form element
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/'; // splash endpoint I know it sucks we need to fix it

  // Add CSRF token
  const csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = 'csrfmiddlewaretoken';
  csrfInput.value = csrftoken;
  form.appendChild(csrfInput);

  // Add email input - name 'your_email' to match splash view form
  const emailInput = document.createElement('input');
  emailInput.type = 'hidden';
  emailInput.name = 'your_email';
  emailInput.value = email;
  form.appendChild(emailInput);

  // Add document slug input - name 'document_slug'
  if (slug) {
    const slugInput = document.createElement('input');
    slugInput.type = 'hidden';
    slugInput.name = 'document_slug';
    slugInput.value = slug;
    form.appendChild(slugInput);
  }

  // Append to body, submit, and remove
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
  // No promise returned as form submission navigates away
};

const toggleText = element => success => {
  if (success) {
    element.querySelector('.error-text').hidden = true;
    element.querySelector('.success-text').hidden = false;
  } else {
    element.querySelector('.error-text').hidden = false;
    element.querySelector('.success-text').hidden = true;
  }
};

const handleSubscribeClick = event => {
  event.preventDefault();
  const clickedButton = event.target; // event.target is the button itself

  // Store original width and apply it
  const originalWidth = clickedButton.offsetWidth;
  clickedButton.style.width = `${originalWidth}px`;

  // Add Tailwind classes for centering the spinner
  utils.addClass(clickedButton, 'flex');
  utils.addClass(clickedButton, 'items-center');
  utils.addClass(clickedButton, 'justify-center');

  const csrftoken = document.querySelector('[name=csrfmiddlewaretoken]').value;
  // The email input is a sibling of the clickedButton, within its parentNode
  const email = clickedButton.parentNode.querySelector('.subscribe-cta-input').value;

  clickedButton.disabled = true;
  clickedButton.innerHTML = '<span class="spinner"></span>'; // Set spinner HTML

  subscribe({ email, slug: SLUG, csrftoken });
};

const handleInput = event => {
  event.preventDefault();
  const email = event.target.value;
  const button = event.target.parentNode.querySelector('.subscribe-cta-button');
  if (!validateEmail(email)) {
    utils.addClass(email.target, 'text-gray-500');
    button.disabled = true;
  } else {
    utils.removeClass(email.target, 'text-gray-500');
    button.disabled = false;
  }
};

const initSubscribeCta = () => {
  if (IS_AUTHENTICATED === true) {
    const ctaContainers = document.querySelectorAll('.subscribe-cta-container');
    ctaContainers.forEach(container => {
      container.style.display = 'none';
    });
    return;
  }

  const buttons = document.querySelectorAll('.subscribe-cta-button');
  buttons.forEach(button => {
    const email = button.parentNode.querySelector('.subscribe-cta-input');
    if (!validateEmail(email)) {
      button.disabled = true;
    }
    button.addEventListener('click', handleSubscribeClick);


  });
  const inputs = document.querySelectorAll('.subscribe-cta-input');
  inputs.forEach(input => {
    input.addEventListener('input', handleInput);
  });
};

document.addEventListener('DOMContentLoaded', initSubscribeCta);
